// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Ct9Hm","label":"Section_label__1alJu","contentWrap":"Section_contentWrap__23zeZ","footer":"Section_footer__3t2Fz","footerInner":"Section_footerInner__36Vz2"};